import Lang from "../components/model/lang/zh";
import LangEN from "../components/model/lang/en";
import FastFoodExample from "../components/model/quick/zh";
import FastFoodExampleEN from "../components/model/quick/en";
import FineDiningExample from "../components/model/meal/zh";
import FineDiningExampleEN from "../components/model/meal/en";
import P1 from "../components/partner/1/zh";
import P2 from "../components/partner/2/zh";
import P3 from "../components/partner/3/zh";
import P4 from "../components/partner/4/zh";
import P5 from "../components/partner/5/zh";

import P1EN from "../components/partner/1/en";
import P2EN from "../components/partner/2/en";
import P3EN from "../components/partner/3/en";
import P4EN from "../components/partner/4/en";
import P5EN from "../components/partner/5/en";


export interface configDto {
  type: string;
  val: string;
}

export type configArrDto = configDto[]


export const features = [
  {
    // 用的翻译key
    title: 'multiLang',
    description: 'Feature 1 Description',
    imgSrc: './features/img.png',
    id: "multiLang",
    zh: <Lang/>,
    en: <LangEN/>,
  },
  {
    title: 'exampleForQuick',
    description: 'Feature 2 Description',
    imgSrc: './features/quick.png',
    id: "exampleForQuick",
    zh: <FastFoodExample />,
    en: <FastFoodExampleEN />,
  },
  {
    title: 'exampleForMeal',
    description: 'Feature 2 Description',
    imgSrc: './features/third.webp',
    id: "exampleForMeal",
    zh:<FineDiningExample />,
    en:<FineDiningExampleEN />,
  },
];

export const partners = [
  {
    title: 'Napoli Coffee',
    description: 'Feature 1 Description',
    imgSrc: './partner/1/9.pic.jpg',
    id: "P1",
    zh: <P1/>,
    en: <P1EN/>,
  },
  {
    title: 'The Red & Luna',
    description: 'Feature 1 Description',
    imgSrc: './partner/2/1.pic.jpg',
    id: "P2",
    zh: <P2/>,
    en: <P2EN/>,
  },
  {
    title: 'kaizen sushi',
    description: 'Feature 1 Description',
    imgSrc: './partner/3/8.pic.jpg',
    id: "P3",
    zh: <P3/>,
    en: <P3EN/>,
  },
  {
    title: 'MICAZO RAMEN',
    description: 'Feature 1 Description',
    imgSrc: './partner/4/5.pic.jpg',
    id: "P4",
    zh: <P4/>,
    en: <P4EN/>,
  },
  {
    title: 'Forest4 Darts Cafe',
    description: 'Feature 1 Description',
    imgSrc: './partner/5/4.pic.jpg',
    id: "P5",
    zh: <P5/>,
    en: <P5EN/>,
  },
]

